The value of `PositionProfile.profileId` for the requested object.
